export const activityCategories = [
  { id: 'all', name: '全部活动' },
  { id: 'daily', name: '每日签到' },
  { id: 'invite', name: '邀请好友' },
  { id: 'engage', name: '内容互动' },
  { id: 'lucky', name: '限时抽奖' },
  { id: 'newbie', name: '新人大礼' },
  { id: 'back', name: '返场福利' },
];

export const activities = [
  {
    id: 'sign-in-7',
    title: '七日签到冲刺 · 满勤再加码',
    summary: '连续签到七天即可解锁额外瓜豆奖励，中途断了也可以从头再来，门槛低、反馈快。',
    category: 'daily',
    reward: '最高 340 瓜豆 + 免单券',
    difficulty: '轻松',
    hot: true,
    deadline: '长期有效',
    participants: '128,430',
    tags: ['每日一次', '即时到账'],
    image: 'https://readdy.ai/api/search-image?query=Minimal%20calendar%20page%20with%20a%20golden%20check%20mark%20and%20a%20small%20gift%20box%20on%20a%20warm%20cream%20background%2C%20flat%20playful%20illustration%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=800&height=600&seq=act-sign-01&orientation=landscape',
  },
  {
    id: 'invite-pool',
    title: '好友同行计划 · 奖励池瓜分',
    summary: '邀请好友完成首次签到即可获得瓜豆，好友连续活跃还能带来额外分成，适合社交型玩家。',
    category: 'invite',
    reward: '50 瓜豆 / 人 + 分成',
    difficulty: '中等',
    hot: true,
    deadline: '每月 30 日结算',
    participants: '96,120',
    tags: ['次日结算', '可叠加'],
    image: 'https://readdy.ai/api/search-image?query=Two%20friendly%20cartoon%20characters%20high%20fiving%20with%20wrapped%20gift%20boxes%20and%20confetti%2C%20warm%20coral%20and%20gold%20palette%2C%20minimal%20flat%20illustration%2C%20clean%20background&width=800&height=600&seq=act-invite-02&orientation=landscape',
  },
  {
    id: 'comment-star',
    title: '神评论征集 · 每周精选',
    summary: '在指定话题下发布有内容的评论，被选为精选即可获得大额瓜豆，玩梗与认真都能被看见。',
    category: 'engage',
    reward: '200 - 800 瓜豆',
    difficulty: '中等',
    hot: true,
    deadline: '每周日 24:00',
    participants: '73,905',
    tags: ['内容为王', '人工审核'],
    image: 'https://readdy.ai/api/search-image?query=Speech%20bubble%20icons%20and%20small%20golden%20stars%20arranged%20on%20a%20peach%20background%2C%20playful%20minimal%20flat%20illustration%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=800&height=600&seq=act-comment-03&orientation=landscape',
  },
  {
    id: 'lucky-hour',
    title: '整点开奖 · 幸运大转盘',
    summary: '每天整点开放转盘，消耗抽奖券即可参与，奖品从瓜豆到大额免单券不等，概率公开可查。',
    category: 'lucky',
    reward: '瓜豆 / 免单券 / 限定周边',
    difficulty: '轻松',
    hot: true,
    deadline: '每日 10:00 - 22:00',
    participants: '201,338',
    tags: ['概率公示', '整点开奖'],
    image: 'https://readdy.ai/api/search-image?query=Colorful%20prize%20wheel%20with%20golden%20coins%20and%20sparkles%20on%20a%20peach%20background%2C%20playful%20flat%20illustration%2C%20minimal%20clean%20composition%2C%20soft%20studio%20lighting&width=800&height=600&seq=act-lucky-04&orientation=landscape',
  },
  {
    id: 'newbie-gift',
    title: '新人见面礼 · 首次参与即领',
    summary: '首次完成任意一个任务，就能解锁新人专属礼包，包含抽奖券与瓜豆，用来试水刚刚好。',
    category: 'newbie',
    reward: '新人礼包 + 5 张抽奖券',
    difficulty: '轻松',
    hot: false,
    deadline: '首次参与后 7 天内',
    participants: '58,741',
    tags: ['仅限一次', '即时到账'],
    image: 'https://readdy.ai/api/search-image?query=Red%20envelope%20packets%20and%20festive%20lanterns%20arranged%20on%20a%20soft%20cream%20background%2C%20warm%20golden%20accents%2C%20minimal%20modern%20illustration%2C%20clean%20composition&width=800&height=600&seq=act-newbie-05&orientation=landscape',
  },
  {
    id: 'watch-reward',
    title: '边看边攒 · 内容浏览任务',
    summary: '完整浏览指定内容满 30 秒即可获得瓜豆，每天最多可完成 8 条，适合通勤时顺手做。',
    category: 'engage',
    reward: '3 瓜豆 / 条',
    difficulty: '轻松',
    hot: false,
    deadline: '长期有效',
    participants: '184,026',
    tags: ['每日 8 条', '即时到账'],
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20a%20reward%20notification%20surrounded%20by%20confetti%20and%20gift%20icons%2C%20warm%20coral%20and%20gold%20palette%2C%20minimal%20flat%20illustration%2C%20clean%20background&width=800&height=600&seq=act-watch-06&orientation=landscape',
  },
  {
    id: 'coin-exchange',
    title: '瓜豆兑换季 · 好物上新',
    summary: '攒够瓜豆可在兑换专区换取好物，每期上新的数量有限，先到先得，库存实时更新。',
    category: 'back',
    reward: '实物好物 / 优惠券',
    difficulty: '中等',
    hot: false,
    deadline: '本季结束前',
    participants: '64,890',
    tags: ['限量兑换', '先到先得'],
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20golden%20coins%20and%20a%20small%20shopping%20bag%20on%20a%20warm%20beige%20background%2C%20minimal%20playful%20illustration%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=800&height=600&seq=act-coin-07&orientation=landscape',
  },
  {
    id: 'return-coupon',
    title: '经典返场 · 券包补领通道',
    summary: '此前错过的限时券包开放补领入口，符合条件的老用户可申请一次补领，逾期不再开放。',
    category: 'back',
    reward: '满减券包',
    difficulty: '轻松',
    hot: false,
    deadline: '返场期结束即止',
    participants: '37,552',
    tags: ['限时补领', '仅限一次'],
    image: 'https://readdy.ai/api/search-image?query=Golden%20lottery%20tickets%20and%20coupons%20fanned%20out%20on%20a%20peach%20background%2C%20playful%20minimal%20illustration%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=800&height=600&seq=act-return-08&orientation=landscape',
  },
  {
    id: 'burst-party',
    title: '周末狂欢 · 加倍奖励时段',
    summary: '每周末 19:00 - 22:00 开启奖励加倍，期间完成的任务瓜豆翻倍，适合集中冲一波进度。',
    category: 'lucky',
    reward: '任务瓜豆 x2',
    difficulty: '轻松',
    hot: true,
    deadline: '每周六日 19:00 - 22:00',
    participants: '142,770',
    tags: ['限时双倍', '周末开启'],
    image: 'https://readdy.ai/api/search-image?query=Colorful%20confetti%20burst%20and%20party%20streamers%20on%20a%20soft%20coral%20background%2C%20playful%20festive%20illustration%2C%20minimal%20clean%20composition%2C%20bright%20cheerful%20mood&width=800&height=600&seq=act-party-09&orientation=landscape',
  },
];